/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCRightIcon16Light = forwardRef('ArrowCRightIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.644 3.149a.5.5 0 0 1 .707-.005l3.843 3.793a1.5 1.5 0 0 1 .006 2.128l-3.788 3.789a.5.5 0 0 1-.707-.708l3.788-3.788a.5.5 0 0 0-.002-.71L5.649 3.857a.5.5 0 0 1-.005-.707Z" })));
});
